import React from 'react'
import { useInvestorOpenVotesCloseToExpiration } from '../../application/features/featuredVotes/hooks'
import { DashboardVotesOpen } from './DashboardVotesOpen'

interface Props {
  handleCallToAction: () => void
}

export const DashboardVotesOpenContainer: React.FC<Props> = ({ handleCallToAction }) => {
  const votes = useInvestorOpenVotesCloseToExpiration()

  return <DashboardVotesOpen votes={votes} handleCallToAction={handleCallToAction} />
}
